import { render, staticRenderFns } from "./CPageGalleryDetailStandard.vue?vue&type=template&id=1619bc4a&"
import script from "./CPageGalleryDetailStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageGalleryDetailStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports